import classNames from 'classnames'
import { MdArrowDownward, MdArrowUpward } from 'react-icons/md'

import type { ReactElement } from 'react'

import './styles.scss'

interface Props {
  value: number
  withArrow?: boolean
}

const TableVariation = ({ value, withArrow = true }: Props): ReactElement => {
  const componentClasses = classNames('table-variation-component', {
    decrease: value < 0,
    increase: value > 0,
  })

  return (
    <div className={componentClasses}>
      {withArrow ? value > 0 ? <MdArrowUpward color="#00c064" /> : <MdArrowDownward color="#ff2e26" /> : null}
      <div className="value-progression">{value > 0 ? '+' + value.toFixed(2) : value.toFixed(2)}%</div>
    </div>
  )
}

export default TableVariation
